import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import ReactTable from '../../elements/ReactTable/ReactTable';
import addCustomColumn from '../../elements/ReactTable/utility/addCustomColumn';
import FormikInput from '../../elements/formik/FormikInput';
const cellStyle = {
    padding: '1px',
    border: 'none',
    borderWidth: 0,
};
const inputStyle = {
    input: {
        padding: '5px',
    },
    inputWrapper: {
        borderRadius: 0,
    },
};
export function SpinSystemTable(props) {
    const { spinSystem } = props;
    const { values: { data }, } = useFormikContext();
    const tableColumns = useMemo(() => {
        const columns = [
            {
                id: 'rowLabel',
                Header: '',
                accessor: (_, index) => spinSystem.at(index),
            },
            {
                Header: 'Delta',
                style: cellStyle,
                Cell: ({ row }) => (_jsx(FormikInput, { name: `data.${row.index}.0`, style: inputStyle, value: row.original[0] || 0, type: "number" })),
            },
        ];
        let i = 0;
        for (const label of spinSystem.slice(0, -1)) {
            const columnIndex = i + 1;
            addCustomColumn(columns, {
                id: label,
                index: i,
                style: cellStyle,
                Cell: function cellRender({ row }) {
                    const val = row.original?.[columnIndex] ?? null;
                    if (val !== null) {
                        return (_jsx(FormikInput, { name: `data.${row.index}.${columnIndex}`, style: inputStyle, type: "number" }));
                    }
                    return _jsx("div", {});
                },
                Header: () => (_jsxs("span", { children: ["J", _jsxs("sub", { children: [label, "-X"] }), "(Hz)"] })),
            });
            i++;
        }
        return columns;
    }, [spinSystem]);
    if (!spinSystem) {
        return null;
    }
    return _jsx(ReactTable, { columns: tableColumns, data: data });
}
